import React from "react";
import AdminLayout from "../layouts/AdminLayout";
import ManageUserView from "../components/manage-user/ManageUserView";

const ManageUser = () => {
  return (
    <AdminLayout>
      <ManageUserView />
    </AdminLayout>
  );
};

export default ManageUser;
 